import { gsap } from 'gsap/all'
import { throttle } from 'throttle-debounce'
import DeviceCheck from '../utils/deviceCheck'
let update = () => {}

// SideNavigation
export default class SideNavigation {
  constructor() {
    this.html = document.querySelector('html')
    this.sideNavi = document.querySelector('.js-side-nav')
    this.header = document.querySelector('.js-header')
    this.sections = document.querySelectorAll('.js-side-nav-section')
    this.sectionArr = Array.prototype.slice.call(this.sections)
    this.sideNaviItems = document.querySelectorAll('.js-side-nav-list li')
    this.sideNaviItemArr = Array.prototype.slice.call(this.sideNaviItems)
    this.sideNaviLinks = document.querySelectorAll('.js-side-nav-link')
    this.sideNaviLinksArr = Array.prototype.slice.call(this.sideNaviLinks)
    this.sideNaviToggle = document.querySelector('.js-side-nav-toggle')
    this.sideNaviBody = document.querySelector('.js-side-nav-body')
    this.margin = 130
    this.current = -1
    this.isOpen = false
    this.isAnimating = false
    this.isFixed = false
    this.DeviceCheck = new DeviceCheck()
    this.init()
  }

  init() {
    if (this.sideNaviToggle) {
      this.setToggle()
    }
    if (document.body.contains(document.querySelector('.js-side-nav-section'))) {
      this.setScrollCurrent()
    }
    // this.setFixedNav() // スクロール監視を初期化
  }

  setToggle() {
    this.sideNaviToggle.addEventListener('click', (e) => {
      if (this.DeviceCheck.getDevice() == 'mobile' || this.DeviceCheck.getDevice() == 'tablet') {
        if (!this.isAnimating) {
          if (this.isOpen == false) {
            if (this.isFixed) {
              this.naviOpen()
            } else {
              this.scrollToNavi()
            }
          } else {
            this.naviClose()
          }
        }
      }
    })

    this.sideNaviItemArr.forEach((el) => {
      el.addEventListener('click', (e) => {
        if (this.DeviceCheck.getDevice() == 'mobile' || this.DeviceCheck.getDevice() == 'tablet') {
          if (!this.isAnimating) {
            if (this.isOpen) {
              this.naviClose()
            }
          }
        }
      })
    })
  }

  setScrollCurrent() {
    update = throttle(100, () => {
      this.update()
    })
    window.addEventListener('resize', update)
    window.addEventListener('scroll', update)
  }

  removeEvent() {
    window.removeEventListener('resize', update)
    window.removeEventListener('scroll', update)
  }

  update() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const sectionTopArr = new Array()
    this.sectionArr.forEach((el, i) => {
      const rect = el.getBoundingClientRect()
      const sectionTop = rect.top + scrollTop
      sectionTopArr[i] = sectionTop
    })

    for (let i = sectionTopArr.length - 1; i >= -1; i--) {
      if (scrollTop < sectionTopArr[0] - this.margin) {
        this.resetCurrent()
        break
      } else if (scrollTop > sectionTopArr[i] - this.margin) {
        this.changeCurrent(i)
        break
      }
    }
  }

  changeCurrent(curNum) {
    if (curNum != this.current) {
      this.current = curNum
      this.sideNaviItemArr.forEach((el) => {
        el.classList.remove('is-current')
      })
      if (this.sideNaviItemArr[curNum]) {
        this.sideNaviItemArr[curNum].classList.add('is-current')
      }
    }
  }

  resetCurrent() {
    this.current = -1
    this.sideNaviItemArr.forEach((el) => {
      el.classList.remove('is-current')
    })
  }

  setFixedNav() {
    window.addEventListener('scroll', () => {
      const headerHeight = this.header.offsetHeight
      const rect = this.sideNavi.getBoundingClientRect()
      if (rect.top <= headerHeight) {
        this.sideNavi.classList.add('is-fixed')

        this.isFixed = true
      } else {
        this.sideNavi.classList.remove('is-fixed')

        this.isFixed = false
      }
    })
  }

  scrollToNavi() {
    gsap.killTweensOf(this.sideNaviBody)
    gsap.killTweensOf(window)
    gsap.to(window, {
      duration: 0.6,
      scrollTo: { y: '.js-side-nav', offsetY: 80, autoKill: false },
      ease: 'power2.inOut',
      onComplete: () => {
        this.naviOpen()
      },
    })
  }

  naviOpen() {
    gsap.killTweensOf(this.sideNaviBody)

    /* add class */
    this.html.classList.add('is-side-nav-open')
    this.sideNavi.classList.add('is-open')

    /* フラグ変更 */
    this.isAnimating = true
    this.isOpen = true

    /* OPENアニメーション */
    var opentl = gsap.timeline()
    opentl
      .set(this.sideNaviBody, {
        opacity: 0,
      })
      .to(
        this.sideNaviBody,
        {
          duration: 0.6,
          height: 'auto',
          ease: 'power3.inOut',
        },
        '<',
      )
      .to(
        this.sideNaviBody,
        {
          duration: 0.6,
          opacity: 1,
          ease: 'power3.inOut',
          onComplete: () => {
            this.isAnimating = false
          },
        },
        '-=0.2',
      )
  }

  naviClose() {
    gsap.killTweensOf(this.sideNaviBody)

    this.sideNavi.classList.remove('is-open')
    this.html.classList.remove('is-side-nav-open')

    /* アニメーション中のフラグ */
    this.isAnimating = true

    /* CLOSEアニメーション */
    var closetl = gsap.timeline()
    closetl
      .to(this.sideNaviBody, {
        duration: 0.2,
        opacity: 0,
        ease: 'power3.out',
      })
      .to(
        this.sideNaviBody,
        {
          duration: 0.6,
          height: 0,
          ease: 'power3.inOut',
          onComplete: () => {
            this.isAnimating = false
            this.isOpen = false
          },
        },
        '-=0.2',
      )
  }
}
